import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomEditCard from '../../../common/components/CustomEditCard/CustomEditCard';
import _ from 'lodash';
import WarningContent from './WarningContent';
import { warningcomplaintService } from '../../../api/services/warningcomplaintService';
import { useAppSelector } from '../../../infra/hooks';
interface propsType {
  trans?: any;
  warningListData: any;
  removeID: (id: string) => void;
}
const Warning: React.FC<propsType> = ({ trans, warningListData, removeID }) => {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state);
  const EmpID = selector.authSlice.emp_id;
  const CompanyID = selector.authSlice.company_id;
  const onClickAccept = async (id: any) => {
    const payload = {
      id: id,
      empId: EmpID,
      companyId: CompanyID,
      empStatus: 'Accept',
    };
    await warningcomplaintService
      .updateEmpWarningStatus(payload)
      .then((res) => {
        if (res?.response) {
          removeID(id);
        }
      })
      .catch((err) => {
        return;
      });
  };
  const onClickReject = async (id: any) => {
    const payload = {
      id: id,
      empId: EmpID,
      companyId: CompanyID,
      empStatus: 'Reject',
    };
    await warningcomplaintService
      .updateEmpWarningStatus(payload)
      .then((res) => {
        if (res?.response) {
          removeID(id);
        }
      })
      .catch((err) => {
        return;
      });
  };
  return (
    <div>
      <CustomEditCard
        card_title={trans('Warning')}
        card_height="380px"
        //onClick={() => setOpenModal(true)}
        showEditButton={false}
      >
        {_.map(warningListData, (data: any) => {
          return (
            <WarningContent
              taxName={data?.subject}
              warningBy={data?.warning_by_name}
              description={data?.description}
              onClickAccept={() => {
                onClickAccept(data?.id);
              }}
              onClickReject={() => {
                onClickReject(data?.id);
              }}
            />
          );
        })}
      </CustomEditCard>
    </div>
  );
};
export default Warning;
